import { History, LogIn } from "lucide-react"
import { Link } from "react-router"
import { Project } from "../types/project.type"
import { DataContext } from "../App"
import { useContext } from "react"
import { useTranslation } from "react-i18next"
import { LanguageSwitch } from "./LanguageSwitch"

export default function Header({
  openLoginModal,
  project,
}: {
  openLoginModal?: () => void
  project: Project
}) {
  const { customer } = useContext(DataContext)
  const { t } = useTranslation('common')

  return (
    <div className="relative z-[2] w-full border-b border-white/15 bg-black/15 backdrop-blur-sm">
      <div className="mx-auto max-w-5xl px-4">
        <header className="flex w-full items-center justify-between gap-4 py-4">
          <Link to="/" className="min-w-0 shrink">
            <div className="flex items-center space-x-2">
              <img
                src={project?.logoImageFiles?.[0]?.s3Url}
                alt={t('logo')}
                className="h-10 w-10 shrink-0 object-contain"
              />
              <span className="truncate text-lg font-semibold text-white">{project?.name}</span>
            </div>
          </Link>

          <div className="flex shrink-0 items-center gap-3 md:gap-5">
            <LanguageSwitch variant="light" />
            <Link to="/" className="relative text-sm font-medium text-white hover:text-white/90">
              <span className="inline-block">{t('home')}</span>
            </Link>
            {project?.aboutUsEnabled && (
              <Link to="/about-us" className="relative text-sm font-medium text-white hover:text-white/90">
                <span className="inline-block">{t('aboutUs')}</span>
              </Link>
            )}
            {project?.allowCustomerLogin && !customer && (
              <div>
                <LogIn
                  className="h-6 w-6 cursor-pointer text-white"
                  onClick={openLoginModal}
                />
              </div>
            )}
            {project?.allowCustomerLogin && customer && (
              <div>
                <History
                  className="h-6 w-6 cursor-pointer text-white"
                  onClick={openLoginModal}
                />
              </div>
            )}
          </div>
        </header>
      </div>
    </div>
  )
}
